import Frame from './component';

export default Frame;
